export const WARRANTIES = [
  {
    name: 'Standard Product Limited Warranty',
    slug: 'standard',
    'Product Defects Coverage': [
      { 'Overall Warranty Length': 'Lifetime' },
      { 'Products Included': 'Shingles & all Owens Corning<sup>&reg;</sup><br />components' },
      { 'TRU PROtection<sup>&reg;</sup> Period': 'First 10 years<sup>1</sup>' },
      { 'Materials Only Coverage': 'After 10 Years' },
      { 'Blow Off Coverage<sup>*/###</sup>': 'First 15 years' },
      { 'StreakGuard<sup>&trade;</sup> Algae Resistance**': 'First 25 years<sup>*</sup>' },
    ],
    'Workmanship Coverage': [{ 'Coverage Period': 'None' }],
    'Key Requirements': [
      { 'Additional Cost': 'None' },
      {
        'Component Products':
          'Min of 3 Owens<br />\
                                    Corning&reg; components<br />\
                                    required***',
      },
      { 'Contractor Certification Required': 'None' },
    ],
  },
  {
    name: 'System Protection Limited Warranty',
    slug: 'system-protection',
    'Product Defects Coverage': [
      { 'Overall Warranty Length': 'Lifetime' },
      { 'Products Included': 'Shingles & all Owens Corning<sup>&reg;</sup><br />components' },
      { 'TRU PROtection<sup>&reg;</sup> Period': 'First 50 years<sup>2</sup>' },
      { 'Materials Only Coverage': 'After 50 Years' },
      { 'Blow Off Coverage<sup>*/###</sup>': 'First 15 years' },
      { 'StreakGuard<sup>&trade;</sup> Algae Resistance**': 'First 25 years<sup>*</sup>' },
    ],
    'Workmanship Coverage': [{ 'Coverage Period': 'None' }],
    'Key Requirements': [
      { 'Additional Cost': 'Yes' },
      {
        'Component Products':
          'Min of 3 Owens<br />\
                                    Corning&reg; components<br />\
                                    required',
      },
      {
        'Contractor Certification Required':
          '\
            Must be installed by an<br />\
            Owens Corning<sup>&reg;</sup><br />\
            Platinum or Preferred<br />\
            Contractor',
      },
    ],
  },
  {
    name: 'Preferred Protection Limited Warranty',
    slug: 'preferred-protection',
    'Product Defects Coverage': [
      { 'Overall Warranty Length': 'Lifetime' },
      { 'Products Included': 'Shingles & all Owens Corning<sup>&reg;</sup><br />components' },
      { 'TRU PROtection<sup>&reg;</sup> Period': 'First 50 years<sup>2</sup>' },
      { 'Materials Only Coverage': 'After 50 Years' },
      { 'Blow Off Coverage<sup>*/###</sup>': 'First 15 years' },
      { 'StreakGuard<sup>&trade;</sup> Algae Resistance**': 'First 25 years<sup>*</sup>' },
    ],
    'Workmanship Coverage': [{ 'Coverage Period': 'First 10 years' }],
    'Key Requirements': [
      { 'Additional Cost': 'Yes' },
      {
        'Component Products':
          'Min of 4 Owens<br />\
                                    Corning&reg; components<br />\
                                    required',
      },
      {
        'Contractor Certification Required':
          '\
                                    Must be installed by an<br />\
                                    Owens Corning<sup>&reg;</sup><br />\
                                    Platinum or Preferred<br />\
                                    Contractor',
      },
    ],
  },
  {
    name: 'Platinum Protection Limited Warranty',
    slug: 'platinum-protection',
    'Product Defects Coverage': [
      { 'Overall Warranty Length': 'Lifetime' },
      { 'Products Included': 'Shingles & all Owens Corning<sup>&reg;</sup><br />components' },
      { 'TRU PROtection<sup>&reg;</sup> Period': 'First 50 years<sup>2</sup>' },
      { 'Materials Only Coverage': 'After 50 Years' },
      { 'Blow Off Coverage<sup>*/###</sup>': 'First 15 years' },
      { 'StreakGuard<sup>&trade;</sup> Algae Resistance**': 'First 25 years<sup>*</sup>' },
    ],
    'Workmanship Coverage': [
      {
        'Coverage Period':
          '\
                Lifetime with coverage<br />\
                reduced after 25 years<br />\
                based on the age of the<br />\
                roof.',
      },
    ],
    'Key Requirements': [
      { 'Additional Cost': 'Yes' },
      {
        'Component Products':
          'Min of 4 Owens<br />\
                                    Corning&reg; components<br />\
                                    required',
      },
      {
        'Contractor Certification Required':
          '\
                Must be installed by an<br />\
                Owens Corning<sup>&reg;</sup><br />\
                Platinum Contractor<br />',
      },
    ],
  },
];

export const POPOVERS = [
  {
    name: 'Overall Warranty Length',
    titleText: 'Overall Warranty Length',
    bodyText:
      'As a single family homeowner, lifetime coverage means that your warranty is in effect as long as you own your home.',
  },
  {
    name: 'TRU PROtection<sup>&reg;</sup> Period',
    titleText: 'TRU PROtection® Period',
    bodyText:
      'Each warranty starts with a TRU PROtection® Period during the initial years where coverage includes labor cost to repair/replace defective materials.',
  },
  {
    name: 'Materials Only Coverage',
    titleText: 'Materials Only Coverage',
    bodyText:
      'After the TRU PROtection® Period is over, warranty compensation is for materials only. The compensation is reduced based on the number of years you’ve enjoyed your roof from installation date through the date of your claim.',
  },
  {
    name: 'Blow Off Coverage<sup>*/###</sup>',
    titleText: '110/130-MPH Wind Blow off Coverage/ 160-MPH for Duration® Series',
    bodyText:
      'After your shingles have achieved thermal sealing they will be covered if they experience blow-offs or wind damage in winds (including gusts) for the wind speed listed for the period from the original installation date.',
  },
  {
    name: 'StreakGuard<sup>&trade;</sup> Algae Resistance**',
    titleText: 'StreakGuard® Algae Resistance**',
    bodyText:
      'Warranty length following the date of installation against brown-black staining caused by growth of cyanobacteria Gloeocapsa magma algae.',
  },
  {
    name: 'Coverage Period',
    titleText: 'Coverage Period',
    bodyText:
      'Contractor workmanship coverage includes any defective installation of the Owens Corning® Roofing System. Contractor workmanship is available only through certified Owens Corning® Roofing Platinum or Preferred Contractors.',
  },
  {
    name: 'Component Products',
    titleText: 'Owens Corning Component Products',
    bodyText:
      'The minimum number of Owens Corning® component product categories that must be installed to qualify for warranty coverage. The categories of component products include underlayments, intake and exhaust ventilation, hip & ridge shingles, ice & water barriers, and starter shingles.',
  },
  {
    name: 'Contractor Certification Required',
    titleText: 'Contractor Certification Required',
    bodyText:
      'Your Owens Corning® Roofing System must be installed by a certified Owens Corning® Roofing Platinum or Preferred Contractor and your contractor must register the warranty within 60 days of the installation.',
  },
];
